




































import { Component, Prop, Vue } from "vue-property-decorator";
import RegisterPelayanan from "@/services/RegisterKunjungan";
import { storePerawat } from "@/store/modules/perawat";
import PasienFlyingBar from "@/components/PasienFlyingBar.vue";
import { storePasien } from "@/store/modules/pasien";
import { storeDokter } from "@/store/modules/dokter";
import { storeUnit } from "@/store/modules/unit";
import DataUtility from "@/services/DataUtility";
import NavRiwayat from "@/components/NavRiwayat.vue";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import AsesmenMedisIgdStore from "@/store/modules/AsesmenMedisIgdStore";
import SurveyPrimerIgdStore from "@/store/modules/SurveyPrimerIgdStore";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import CatatanPemberianObatStore from "@/store/modules/CatatanPemberianObat";
import { storeMonitoringKritisIgd } from "@/store/modules/MonitoringKritisIgdStore";

@Component({
  components: {
    PasienFlyingBar,
    NavRiwayat
  },
  beforeCreate() {
    const reg = RegisterPelayanan.get(this.$route.params.register);

    reg.catch(err => {
      if (err.response?.status === 404) {
        this.$router.push("/404");
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    AsesmenAwalRanapMedisStore.reset();
    AsesmenMedisIgdStore.reset();
    SurveyPrimerIgdStore.reset();
    CpptRanapStore.reset();
    SoapRanapStore.reset();
    CatatanPemberianObatStore.reset();
    storeMonitoringKritisIgd.reset();

    next();
  }
})
export default class PemeriksaanIgd extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;

  mounted() {
    storePerawat.actListPerawatall();
    storeDokter.act_dokter_all();
    storePasien.act_pasien_last_reg(this.rm);
    storeUnit.act_on_all_pagi();
    storeUnit.getUnitRanap();
  }

  tabs = [
    {
      name: "Rekam Medis",
      route: { name: `pemeriksaan-igd.rekam-medis` }
    },
    { name: "Resep Obat", route: { name: `pemeriksaan-igd.resep-obat` } },
    {
      name: "Penunjang Medis",
      route: { name: `pemeriksaan-igd.penunjang-medis` }
    },
    {
      name: "Konsul & Rujukan",
      route: { name: `pemeriksaan-igd.konsul-rujukan` }
    },
    {
      name: "Resume & Surat Keterangan",
      route: { name: `pemeriksaan-igd.resume-suket` }
    }
  ];
  activeTab = null;
  faskesList = [];
  openDrawer = true;

  getFaskesList() {
    const faskes = DataUtility.getListFaskes();
    faskes.then(faskes => {
      this.faskesList = faskes;
    });
  }

  openRightDrawer(v) {
    this.openDrawer = v;
  }
}
